import { render } from "./SelectComparator.vue?vue&type=template&id=3668f0fa&scoped=true&ts=true"
import script from "./SelectComparator.vue?vue&type=script&lang=ts"
export * from "./SelectComparator.vue?vue&type=script&lang=ts"

import "./SelectComparator.vue?vue&type=style&index=0&id=3668f0fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3668f0fa"]])

export default __exports__